"use client"
import React, { useState, useEffect } from "react";
import { Modal } from "./modal";
import { Button } from "../../components/ui/button";
import { RadioGroup } from "../../components/ui/radio-group/RadioGroup";
import { RadioGroupItem } from "../ui/radio-group/RadioGroupItem";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";

export function SignupModal({ isOpen, onClose, onLoginClick }) {
  const [accountType, setAccountType] = useState("employee");
  const [showSignup1Modal, setShowSignup1Modal] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  // Vérifier si l'utilisateur connecté est Admin
  useEffect(() => {
    const authData = localStorage.getItem("auth_data");
    if (authData) {
      const user = JSON.parse(authData);
      setIsAdmin(user.role === "Admin");
    }
  }, [isOpen]);

  const handleContinue = () => {
    if (!isAdmin) {
      alert("Seuls les administrateurs peuvent créer des comptes.");
      return;
    }
    setShowSignup1Modal(true);
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <div className="p-6">
          <h2 className="text-3xl font-semibold text-center text-[#5e17eb] mb-6">Rejoignez PolyMeet</h2>
          
          {!isAdmin ? (
            <div className="text-center">
              <p className="text-red-500 mb-4">
                ⚠️ Seuls les administrateurs peuvent créer des comptes.
              </p>
              <p className="text-gray-600 mb-6">
                Veuillez contacter votre administrateur pour obtenir un compte.
              </p>
              <Button
                onClick={onLoginClick}
                className="w-full bg-[#5e17eb] hover:bg-[#7c3aed] text-white"
              >
                Se connecter
              </Button>
            </div>
          ) : (
            <>
              <p className="text-center text-lg text-gray-600 mb-6">
                Sélectionnez le rôle que vous souhaitez créer
              </p>

              <RadioGroup value={accountType} onValueChange={setAccountType} className="space-y-4">
                <div
                  className={`border rounded-md p-4 cursor-pointer transition-all ${
                    accountType === "employee" ? "border-[#5e17eb] bg-[#f3edff]" : "border-gray-200"
                  }`}
                  onClick={() => setAccountType("employee")}
                >
                  <div className="flex items-center space-x-2">
                    <RadioGroupItem value="employee" id="employee" selectedValue={accountType} onValueChange={setAccountType} />
                    <Label htmlFor="employee" className="font-medium cursor-pointer">
                      Employé
                    </Label>
                  </div>
                </div>

                <div
                  className={`border rounded-md p-4 cursor-pointer transition-all ${
                    accountType === "manager" ? "border-[#5e17eb] bg-[#f3edff]" : "border-gray-200"
                  }`}
                  onClick={() => setAccountType("manager")}
                >
                  <div className="flex items-center space-x-2">
                    <RadioGroupItem value="manager" id="manager" selectedValue={accountType} onValueChange={setAccountType} />
                    <Label htmlFor="manager" className="font-medium cursor-pointer">
                      Manager
                    </Label>
                  </div>
                </div>

                <div
                  className={`border rounded-md p-4 cursor-pointer transition-all ${
                    accountType === "admin" ? "border-[#5e17eb] bg-[#f3edff]" : "border-gray-200"
                  }`}
                  onClick={() => setAccountType("admin")}
                >
                  <div className="flex items-center space-x-2">
                    <RadioGroupItem value="admin" id="admin" selectedValue={accountType} onValueChange={setAccountType} />
                    <Label htmlFor="admin" className="font-medium cursor-pointer">
                      Admin
                    </Label>
                  </div>
                </div>
              </RadioGroup>

              <Button
                onClick={handleContinue}
                className="w-full bg-[#5e17eb] hover:bg-[#7c3aed] text-white mt-6"
              >
                Continuer
              </Button>
            </>
          )}

          <div className="text-center mt-4 text-sm text-gray-600">
            Déjà inscrit ?{" "}
            <button
              onClick={onLoginClick}
              className="text-[#5e17eb] hover:text-[#7c3aed] rounded-md transition-colors"
            >
              Se connecter
            </button>
          </div>
        </div>
      </Modal>

      {showSignup1Modal && (
        <Signup1Modal
          isOpen={showSignup1Modal}
          onClose={() => setShowSignup1Modal(false)}
          accountType={accountType}
          onLoginClick={onLoginClick}
        />
      )}
    </>
  );
}

function Signup1Modal({ isOpen, onClose, accountType, onLoginClick }) {
  const rawBackendUrl = process.env.REACT_APP_BACKEND_URL || "";
  const backend_url = rawBackendUrl.startsWith("http://") || rawBackendUrl.startsWith("https://")
    ? rawBackendUrl
    : `https://${rawBackendUrl}`;
  const [formData, setFormData] = useState({
    name: "",
    email: "",
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  // Récupérer le token de l'admin connecté
  const getToken = () => localStorage.getItem("access_token");

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    let roleName = "";
    if (accountType === "admin") roleName = "Admin";
    else if (accountType === "manager") roleName = "Manager";
    else roleName = "Employé";

    const userData = {
      name: formData.name,
      email: formData.email,
      role: roleName,
    };

    const token = getToken();
    if (!token) {
      setError("Vous devez être connecté en tant qu'admin pour créer un compte.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${backend_url}/api/users/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}` 
        },
        body: JSON.stringify(userData),
      });

      const responseText = await response.text();
      let responseData = {};
      try {
        responseData = responseText ? JSON.parse(responseText) : {};
      } catch {
        responseData = {};
      }
      console.log("Réponse du backend:", responseData);

      if (!response.ok) {
        throw new Error(responseData.error || responseData.message || "Erreur lors de la création du compte.");
      }

      setSuccess(true);
      setError(null);
      setFormData({ name: "", email: "" });
      
    } catch (err) {
      console.error("Erreur:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleContinueToLogin = () => {
    onClose();
    onLoginClick();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-6 w-full mx-auto max-w-md">
        <h2 className="text-3xl font-semibold text-center text-[#5e17eb] mb-3">
          Créer un compte {accountType === "admin" ? "Admin" : accountType === "manager" ? "Manager" : "Employé"}
        </h2>

        {success ? (
          <div className="text-center">
            <p className="text-xl text-green-600 mb-4">✅ Compte créé avec succès !</p>
            <p className="text-sm text-gray-600 mb-6">
              Un mot de passe temporaire a été envoyé par email à {formData.email}
            </p>
            <Button
              onClick={handleContinueToLogin}
              className="w-full bg-[#5e17eb] hover:bg-[#7c3aed] text-white"
            >
              Continuer
            </Button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="w-full space-y-4">
            <div className="space-y-2">
              <Label htmlFor="name">Nom complet</Label>
              <Input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={loading}
                placeholder="ex: Jean Dupont"
                className="w-full p-2 border rounded"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={loading}
                placeholder="ex: jean@entreprise.com"
                className="w-full p-2 border rounded"
              />
            </div>
            
            {error && (
              <div className="text-red-500 text-sm mt-2 p-3 bg-red-50 rounded border border-red-200">
                ❌ {error}
              </div>
            )}

            <Button 
              type="submit" 
              className="w-full bg-[#5e17eb] hover:bg-[#7c3aed] text-white"
              disabled={loading}
            >
              {loading ? "Création en cours..." : "Créer le compte"}
            </Button>
          </form>
        )}
      </div>
    </Modal>
  );
}
